export default __webpack_public_path__ + "static/media/test_upload.d17546d2.jpg";